// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Pervasives from "../../../../../../../node_modules/rescript/lib/es6/pervasives.js";
import * as WalletType from "../entity/WalletType.bs.js";
import * as Json_decode from "../../../../../../../node_modules/@glennsl/bs-json/src/Json_decode.bs.js";
import * as Timestamp$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as WalletTransactionStatus from "../entity/WalletTransactionStatus.bs.js";

function decodeTransaction(json) {
  return {
          uuid: Json_decode.field("txn_uuid", Json_decode.string, json),
          amount: Json_decode.field("amount", Json_decode.$$float, json),
          title: Json_decode.field("title", Json_decode.string, json),
          subtitle: Json_decode.field("subtitle", Json_decode.string, json),
          type_: WalletType.fromString(Json_decode.field("txn_type", Json_decode.string, json)),
          status: WalletTransactionStatus.fromString(Json_decode.field("status", Json_decode.string, json)),
          ts: Timestamp$Catalyst.make(Json_decode.field("ts", Json_decode.$$float, json) * 1000.0),
          statusReason: Json_decode.field("status_reason", (function (param) {
                  return Json_decode.optional(Json_decode.string, param);
                }), json),
          adminEmail: Json_decode.optional((function (param) {
                  return Json_decode.field("admin_email", Json_decode.string, param);
                }), json),
          adminComment: Json_decode.optional((function (param) {
                  return Json_decode.field("admin_comment", Json_decode.string, param);
                }), json),
          orderId: Json_decode.field("order_id", (function (param) {
                  return Json_decode.optional(Json_decode.string, param);
                }), json)
        };
}

function execute(json) {
  return {
          balanceAmount: Json_decode.field("balance_amount", Json_decode.$$float, json),
          walletVersionId: Json_decode.field("wallet_version_id", Json_decode.$$int, json),
          transactions: Json_decode.field("txns", (function (param) {
                  return Json_decode.list(decodeTransaction, param);
                }), json),
          offset: Json_decode.field("txn_offset_value", Json_decode.$$int, json)
        };
}

var WalletReportStateMapper = {
  execute: execute
};

function reasonMapper(json) {
  return {
          id: String(Json_decode.field("id", Json_decode.$$int, json)),
          label: Json_decode.field("reason", Json_decode.string, json),
          value: Json_decode.field("reason", Json_decode.string, json)
        };
}

function transactionReasonsMapper(json) {
  return {
          credit: Json_decode.field("credit", (function (param) {
                  return Json_decode.list(reasonMapper, param);
                }), json),
          debit: Json_decode.field("debit", (function (param) {
                  return Json_decode.list(reasonMapper, param);
                }), json)
        };
}

function execute$1(json) {
  return Json_decode.field("reason", transactionReasonsMapper, json);
}

var AdminTransactionReasonsMapper = {
  reasonMapper: reasonMapper,
  transactionReasonsMapper: transactionReasonsMapper,
  execute: execute$1
};

function parsePartnerRequest(json) {
  return {
          driver_msisdn: Json_decode.field("driver_msisdn", Json_decode.string, json),
          vehicle_number: Json_decode.field("vehicle_number", Json_decode.string, json),
          amount: Json_decode.field("amount", Json_decode.$$float, json),
          partner_comment: Json_decode.field("partner_comment", Json_decode.string, json),
          admin_comment: Json_decode.field("admin_comment", Json_decode.string, json)
        };
}

function parsePartnerRequestError(json) {
  return {
          request: Json_decode.field("driver_request", parsePartnerRequest, json),
          error_message: Json_decode.field("failure_reason", Json_decode.string, json)
        };
}

function getFailedPartnerRequests(json) {
  return Json_decode.field("errors", (function (param) {
                return Json_decode.list(parsePartnerRequestError, param);
              }), json);
}

function execute$2(json) {
  var errorType = Json_decode.field("error_type", Json_decode.string, json);
  switch (errorType) {
    case "DRIVER_REQUEST_FAILURE" :
        return /* InvalidPartnersError */{
                _0: getFailedPartnerRequests(json)
              };
    case "DUPLICATE_REQUEST" :
        return /* DuplicateFileNameError */0;
    default:
      return Pervasives.failwith("BulkUpload error-type not found");
  }
}

var BulkUploadTransactionsErrorMapper = {
  parsePartnerRequest: parsePartnerRequest,
  parsePartnerRequestError: parsePartnerRequestError,
  getFailedPartnerRequests: getFailedPartnerRequests,
  execute: execute$2
};

export {
  decodeTransaction ,
  WalletReportStateMapper ,
  AdminTransactionReasonsMapper ,
  BulkUploadTransactionsErrorMapper ,
  
}
/* Timestamp-Catalyst Not a pure module */
